import { render, staticRenderFns } from "./ApkVersion.vue?vue&type=template&id=61a0e474&scoped=true&"
import script from "./ApkVersion.vue?vue&type=script&lang=js&"
export * from "./ApkVersion.vue?vue&type=script&lang=js&"
import style0 from "./ApkVersion.vue?vue&type=style&index=0&id=61a0e474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a0e474",
  null
  
)

export default component.exports